/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../hooks/useAPIError';
import { IconX } from '../../Icons';
import { MisDatosService } from '../../services';
import { DirectionData } from '../../types/PersonalData';

interface Props {
  directionData: DirectionData;
  cargarDirecciones: () => void;
  showOrHideDeletePopup: (data: DirectionData, show: boolean) => void;
  visible: boolean;
}

const ModalDeleteDir: FC<Props> = (props) => {
  const {
    cargarDirecciones,
    directionData,
    showOrHideDeletePopup,
    visible,
  } = props;
  const { addError, addErrorBack } = useAPIError();
  const { t } = useTranslation();

  const DeleteDireccion = (data: DirectionData) => {
    const dir = {
      idDireccion: data.idDireccion,
      tipoDireccion: data.tipoDireccion,
    };
    MisDatosService.deleteDireccion(dir)
      .then((response) => {
        if (response.data.error === true) {
          addErrorBack(response.data);
          showOrHideDeletePopup(data, false);
        } else {
          showOrHideDeletePopup(data, false);
          cargarDirecciones();
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  //* *** Save with Enter key

  const saveInfo = (e) => {
    if (visible) {
      if (e.key === 'Enter' && e.keyCode === 13) {
        const element = document.querySelector(
          'div.modal.modal--small.is-active',
        ) as HTMLElement;
        element.removeEventListener('keydown', saveInfo, false);

        e.preventDefault();
        e.stopPropagation();
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        document
          .getElementById(`delete-dir-${directionData.idDireccion}-btn`)
          .click();
      }
    }
  };

  useEffect(() => {
    if (visible) {
      const element = document.querySelector(
        'div.modal.modal--small.is-active',
      ) as HTMLElement;

      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <>
      <div
        className="modal modal--small"
        // className={`modal modal--small ${showDeletePopup ? 'is-active' : ''}`}
        id={`modal-error-${directionData.idDireccion}`}
      >
        <div className="modal__background" />
        <div className="modal__card u-text-center">
          <header className="modal__card-head u-flex">
            <div className="modal__card-title">
              {t('datos.directions.title-delete-popup')}
            </div>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href="#"
              className="modal__card-close"
              modal-cerrar="true"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                showOrHideDeletePopup(directionData, false);
                // setShowDeletePopup(false);
              }}
            >
              <div className="icon icon-medium icon--close">
                <IconX classCss="" />
              </div>
            </a>
          </header>
          <section className="modal__card-body">
            <p>{t('datos.directions.body-delete-popup')}</p>
            <div className="modal__botonera">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <a
                className="btn btn-secundary u-margin-bottom"
                onClick={() => showOrHideDeletePopup(directionData, false)}
                // onClick={() => setShowDeletePopup(false)}
              >
                {t('datos.accessdata.cancelar')}
              </a>
              <button
                id={`delete-dir-${directionData.idDireccion}-btn`}
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  DeleteDireccion(directionData);
                }}
              >
                {t('datos.accessdata.accept')}
              </button>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};
export default ModalDeleteDir;
